import { buildApiUrl } from './api';

export function formatMoney(value) {
  return Number(value || 0).toLocaleString('es-AR', {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
  });
}

export function formatDate(value, options = {}) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return new Intl.DateTimeFormat('es-AR', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    ...options,
  }).format(date);
}

export function normalizeToken(value) {
  return String(value || '')
    .trim()
    .toUpperCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[\s-]+/g, '_');
}

export function orderProcessLabel(order) {
  const state = normalizeToken(order?.estadoInterno);
  if (state.includes('SAADIS') || state.includes('PROCES')) return 'Procesado';
  if (state.includes('PAGADO') || state === 'LISTO') return 'Listo para procesar';
  if (state.includes('CANCEL')) return 'Cancelado';
  return 'Pendiente de procesar';
}

export function orderPaymentLabel(order) {
  return normalizeToken(order?.cobroEstado) === 'APROBADO' ? 'Flete abonado' : 'Flete pendiente';
}

export function orderPaymentPending(order) {
  return normalizeToken(order?.cobroEstado) !== 'APROBADO';
}

export function statusTone(value) {
  const token = normalizeToken(value);
  if (token === 'PAGADA' || token === 'APROBADO' || token.includes('PROCES')) return 'success';
  if (token.includes('PENDIENTE') || token === 'AGUARDANDO_PAGO') return 'warning';
  if (token.includes('CANCEL') || token.includes('ERROR')) return 'danger';
  return 'info';
}

export function getInitials(user, cliente) {
  const source = `${cliente?.nombre || ''} ${cliente?.apellido || ''}`.trim() || user?.email || 'ESA';
  const parts = source.split(/\s+/).filter(Boolean);
  if (parts.length > 1) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  return source.slice(0, 2).toUpperCase();
}

export async function openAuthenticatedPdf(authFetch, path) {
  const response = await authFetch(path, { headers: { Accept: 'application/pdf' } });
  if (!response.ok) {
    throw new Error(`No se pudo abrir el archivo (${response.status}).`);
  }

  const blob = await response.blob();
  openPdfBlob(blob);
}

export async function openAuthenticatedPdfPost(authFetch, path, body) {
  const response = await authFetch(path, {
    method: 'POST',
    headers: {
      Accept: 'application/pdf',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const text = await response.text().catch(() => '');
    throw new Error(text || `No se pudo abrir el archivo (${response.status}).`);
  }

  const blob = await response.blob();
  openPdfBlob(blob);
}

function openPdfBlob(blob) {
  const url = URL.createObjectURL(blob);
  const tab = window.open(url, '_blank', 'noopener,noreferrer');
  if (!tab) {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.target = '_blank';
    anchor.rel = 'noreferrer';
    anchor.click();
  }
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
}

export function externalTrackingUrl(trackingNumber) {
  if (!trackingNumber) return '';
  return `https://soft.esalogistica.com.ar/esa-portal-autogestion/#/seguituenvio?tracking=${encodeURIComponent(trackingNumber)}`;
}

export function apiAssetUrl(path) {
  return buildApiUrl(path);
}
